// Função auxiliar para renderizar o ícone de status do step
function renderStepIcon(status) {
  if (status === "Concluído") {
    return <CheckIcon className="icon-svg" />;
  }
  if (status === "Recusado") {
    return <CloseXIcon className="icon-svg" />;
  }
  return null;
}
import { CheckIcon, CleanFiltersIcon, CloseXIcon } from "~misc/icons";
import { Accordion, AccordionButton, AccordionItem, AccordionPanel } from "@chakra-ui/react";
import { useState } from "react";
import PropTypes from "prop-types";

import formatDate from "~services/utils/formatDate";

const SolicitacoesCard = ({
  solicitacao,
  title,
  origem,
  produtos,
  observacao,
  status,
  steps,
  data,
  handleAddButton,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`prices-table-solicitacao-card ${isOpen ? "isOpen" : ""}`}>
      <div className="card-header">
        <div className="title-container">
          <h3 className="title">Solicitação {title}</h3>

          {origem && <span className="sub-title">Solicitação de: {origem}</span>}
          <p className="sub-title">Data da Negociação: {formatDate(data)}</p>
        </div>
        <span className={`status ${status?.toLowerCase()}`}>{status}</span>
      </div>
      <div className="card-body">
        <div className="left">
          {(Object.keys(produtos) || [])?.map((cliente) => (
            <span className="client" key={cliente}>
              {cliente}
              {(Array.isArray(produtos[cliente]) ? produtos[cliente] : []).map((p) => (
                <p key={p.id || p.produtoLabel} className="desc">
                  {p.produtoLabel}
                </p>
              ))}
            </span>
          ))}
        </div>
      </div>

      {steps?.length > 0 && (
        <div className="card-footer">
          <Accordion allowToggle={true}>
            <AccordionItem>
              <AccordionButton
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                {isOpen ? "Exibir menos" : "Exibir mais"}
              </AccordionButton>
              <AccordionPanel>
                <div className="card-footer-pannel">
                  {status == "Recusado" && (
                    <p className="title">
                      Observações <br />
                      {observacao}
                    </p>
                  )}

                  {steps?.length ? (
                    <ul className="list">
                      {steps?.map((step) => (
                        <li
                          key={
                            (step.cargo || "") +
                            "-" +
                            (step.autor || "") +
                            "-" +
                            (step.status || "") +
                            "-" +
                            (step.data || "")
                          }
                          className={`item ${step.status.toLowerCase()}`}
                        >
                          <div className="icon-container">
                            <div className="icon">{renderStepIcon(step.status)}</div>
                          </div>
                          <div className="text-container">
                            <span className="card-title">{step.cargo}</span>
                            <span className="name">{step.autor}</span>

                            <div className="status">
                              <span className="status-name">{step.status}</span>
                              <span className="status-date">{step.data}</span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : null}

                  {status == "Recusado" && (
                    <div className="retry-negotiation-container">
                      <button
                        className="retry-negotiation"
                        onClick={() => {
                          if (typeof handleAddButton === "function") {
                            if (solicitacao.origem === "Simulador") {
                              const produtos = Object.values(solicitacao?.produtos);
                              handleAddButton(
                                produtos[0][0].grupoProdutoId,
                                produtos[0][0].id,
                                produtos[0][0].filialId,
                                solicitacao?.clienteId,
                                "editar"
                              );
                            } else {
                              handleAddButton(
                                solicitacao?.grupoProdutoId,
                                solicitacao?.produtosFull[0].produtoId,
                                solicitacao?.filialId,
                                solicitacao?.clienteId,
                                "editar"
                              );
                            }
                          }
                        }}
                      >
                        Refazer Negociação
                        <CleanFiltersIcon className="icon" />
                      </button>
                    </div>
                  )}
                </div>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </div>
      )}
    </div>
  );
};

SolicitacoesCard.propTypes = {
  solicitacao: PropTypes.object,
  title: PropTypes.string,
  origem: PropTypes.string,
  produtos: PropTypes.object,
  observacao: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  status: PropTypes.string,
  steps: PropTypes.array,
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  handleAddButton: PropTypes.func,
};

export default SolicitacoesCard;
